export default "__VITE_PUBLIC_ASSET__27404916__"